var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterSquarelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7857 0H3.21429C1.43973 0 0 1.43973 0 3.21429V26.7857C0 28.5603 1.43973 30 3.21429 30H26.7857C28.5603 30 30 28.5603 30 26.7857V3.21429C30 1.43973 28.5603 0 26.7857 0ZM23.5112 10.6339C23.5246 10.8214 23.5246 11.0156 23.5246 11.2031C23.5246 17.0089 19.1049 23.6987 11.029 23.6987C8.53795 23.6987 6.22768 22.9754 4.28571 21.7299C4.64062 21.7701 4.98214 21.7835 5.34375 21.7835C7.39955 21.7835 9.28795 21.0871 10.7946 19.9085C8.86607 19.8683 7.24554 18.6027 6.68973 16.8616C7.36607 16.9621 7.97545 16.9621 8.67188 16.7812C6.66295 16.3728 5.15625 14.6049 5.15625 12.4687V12.4152C5.73884 12.7433 6.42187 12.9442 7.13839 12.971C6.536 12.5703 6.04218 12.0267 5.70098 11.3887C5.35979 10.7507 5.18185 10.0382 5.18304 9.31473C5.18304 8.49777 5.39732 7.74777 5.77902 7.09821C7.94196 9.76339 11.1897 11.5045 14.8326 11.692C14.2098 8.71205 16.4397 6.29464 19.1183 6.29464C20.3839 6.29464 21.5223 6.82366 22.3259 7.6808C23.317 7.4933 24.2679 7.125 25.1116 6.62277C24.7835 7.64062 24.0938 8.49777 23.183 9.04018C24.067 8.94643 24.9241 8.69866 25.7143 8.35714C25.1183 9.23438 24.3683 10.0112 23.5112 10.6339Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterSquarelogo);
export default __webpack_public_path__ + "static/media/twitter-square logo.58aad13ee38e598b59ce13e4c4b97787.svg";
export { ForwardRef as ReactComponent };